import { Textarea } from './ui/Input';
import SequenceBuilder, { type SequenceItem } from './SequenceBuilder';
import ButtonBuilder, { type ButtonNode } from './ButtonBuilder';

export interface ResponseConfig {
  replyText: string;
  steps: SequenceItem[];
  buttons: ButtonNode[];
}

interface ResponseConfigFormProps {
  value: ResponseConfig;
  onChange: (value: ResponseConfig) => void;
}

export default function ResponseConfigForm({ value, onChange }: ResponseConfigFormProps) {
  return (
    <div className="space-y-5">
      <Textarea
        label="متن پاسخ خودکار"
        value={value.replyText}
        onChange={(e) => onChange({ ...value, replyText: e.target.value })}
        placeholder="متنی که به عنوان اولین پاسخ ارسال می‌شود..."
        rows={3}
      />
      <SequenceBuilder items={value.steps} onChange={(steps) => onChange({ ...value, steps })} />
      <ButtonBuilder
        buttons={value.buttons}
        onChange={(buttons) => onChange({ ...value, buttons })}
      />
    </div>
  );
}
